<div *ngIf="!childrenLinks">
    <app-loading-dots></app-loading-dots>
</div>
<app-page-links
    *ngIf="childrenLinks && childrenLinks!.length"
    [data]="{
        title: data.childrenListTitle,
        subtitle:
            data.childrenListSubtitle &&
            (data.childrenListSubtitle | formatString: { quantity: childrenLinks!.length + '' }),
        links: childrenLinks,
        goToLinkText: data.goToLinkText || ('childrenLinks.goToLink' | translateSafe),
        sortByPageType: data.childrenSortByPageType
    }"
></app-page-links>
